import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Backdrop, ModalBox } from './modal.styles';
import { CustomButton, CustomText, WrapperContainer } from '@corporate-trip-planner-fe/ui-styles';
export var ModalWrapper = function (_a) {
    var modalRegistry = _a.modalRegistry, activeModal = _a.activeModal, onClose = _a.onClose;
    if (!activeModal || !activeModal.name)
        return null;
    var registryEntry = modalRegistry[activeModal.name];
    if (!registryEntry)
        return null;
    var ModalComponent = registryEntry.component, defaultOptions = registryEntry.defaultOptions;
    // Merge default options with options from Redux (Redux overrides default)
    var mergedOptions = __assign(__assign({}, defaultOptions), activeModal.options);
    return (_jsx(Backdrop, { children: _jsxs(ModalBox, { "$size": mergedOptions.size, children: [!mergedOptions.hideHeader && (_jsxs(WrapperContainer, { "$padding": '0', "$justifyContent": 'space-between', "$responsive": false, children: [_jsx(CustomText, { "$fontWeight": '700', "$fontSize": '1.25rem', children: mergedOptions.title }), _jsx(CustomButton, { buttonColor: 'neutral', variant: 'text', onClick: onClose, children: "\u2715" })] })), _jsx(ModalComponent, __assign({}, activeModal.props))] }) }));
};
